<nav class="navbar  navbar-expand-lg navbar-dark px-3 px-md-5 py-3 bg-alag-blue">
    <div class="container-fluid justify-content-center">
        <a class="navbar-brand px-2 d-flex align-items-center" href="#">
            <!-- <img src="../../assets/images/bitssa.svg" alt="" width="45" height="36" class="d-inline-block align-text-top mx-2 bg-light"> -->
            <span class=" rounded p-2 font-weight-bold font-funky" style="letter-spacing: 2px;">BITSSA</span>
        </a>
        <button class="navbar-toggler border border-primary d-none" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse justify-content-end" id="navbarNav">
            <ul class="navbar-nav">
                <li class="nav-item text-center px-2 my-1" *ngIf="!authService.isAuthenticated()">
                    <!-- <button class="px-5 py-2 btn-custom" data-toggle="modal" data-target="#loginRegisterModal">Login</button> -->
                    <button class="px-5 py-2 btn-custom font-inter-med" data-toggle="modal" data-target="#loginRegisterModal">Login</button>
                </li>
                <li class="nav-item text-center px-2 my-1" *ngIf="transactionService.isConnectedWallet">
                    <button class="px-5 py-2 btn-custom font-inter-med">
                        {{ transactionService.connectedWalletAddressModified+'...' }}
                    </button>
                </li>
                <!-- <li class="nav-item text-center px-2 my-1" *ngIf="authService.isAuthenticated() && showOnMenu('connect')">
                    <button class="px-5 py-2 btn-custom font-inter-med" [disabled]="transactionService.isConnectedWallet" (click)="connectWallet()">
                        {{ transactionService.isConnectedWallet ? transactionService.connectedWalletAddressModified+'...' : 'Connect to wallet'}}
                    </button>
                </li> -->
                <!-- <li class="nav-item text-center px-2 my-1" *ngIf="authService.isAuthenticated() && showOnMenu('app')">
                    <button class="px-5 py-2 btn-custom font-inter-med" (click)="changeActive('app')" [ngClass]="{'active': active=='app'}">App</button>
                </li> -->
                <!-- <li class="nav-item text-center px-2 my-1" *ngIf="authService.isAuthenticated() && showOnMenu('transactions')">
                    <button class="px-5 py-2 btn-custom font-inter-med" (click)="changeActive('transactions')" [ngClass]="{'active': active=='transactions'}">Transactions</button>
                </li> -->
                <!-- <li class="nav-item text-center px-2 my-1" *ngIf="authService.isAuthenticated() && showOnMenu('buy')">
                    <button class="px-5 py-2 btn-custom" (click)="changeActive('buy')" [ngClass]="{'active': active=='buy'}">Buy coins</button>
                </li> -->
                <li class="nav-item text-center px-2" *ngIf="authService.isAuthenticated()">
                    <a class="nav-link text-white font-inter-med">Hi, {{authService.user.username}}</a>
                </li>
                <li class="nav-item text-center px-2 " *ngIf="authService.isAuthenticated()">
                    <a class="nav-link cursor-pointer text-white font-inter-med" (click)="authService.signOut()">Sign out</a>
                </li>
            </ul>
        </div>
    </div>
</nav>